import classNames from 'classnames';
import { useIntl } from 'react-intl';

import { getImageAtSize } from '../../../lib/utils';

import headerImageEn from '../../../../img/iga/tablee_title_en.png';
import headerImageFr from '../../../../img/iga/tablee_title_fr.png';
import styles from '../../../../styles/themes/iga/iga-tablee-splash.module.css';

interface IgaTableeSplashProps {
    image: Image;
    tagline: string;
    className: string | null;
}

function IgaTableeSplash({ image = null, tagline, className = null }: IgaTableeSplashProps) {
    const { locale } = useIntl();
    const { url: imageUrl = null } = getImageAtSize(image, 'medium') || {};

    return (
        <div className={classNames([styles.container, className])}>
            <img src={locale === 'fr' ? headerImageFr : headerImageEn} className={styles.header} />
            <div
                className={styles.title}
                dangerouslySetInnerHTML={{ __html: tagline.split('\n')[0] }}
            />
            {imageUrl !== null ? (
                <img src={imageUrl} className={styles.splash} alt="Splash" />
            ) : null}
            <div
                className={styles.subtitle}
                dangerouslySetInnerHTML={{ __html: tagline.split('\n')[1] }}
            />
        </div>
    );
}

export default IgaTableeSplash;
